import { HandleFormDataGet } from '../../../application';

export default class FormDataGetService {
    async RequestData(event) {
        const data = await HandleFormDataGet(event);

        return data;
    }
}
